import React from "react";
import { Link } from "react-router-dom";
import { toMarketingUrl } from "../constants/siteDomains";

type DomainNavLinkProps = {
  to: string;
  className?: string;
  onClick?: () => void;
  onMouseEnter?: () => void;
  children: React.ReactNode;
};

/** Link interno ou absoluto conforme o domínio (marketing ↔ app). */
export const DomainNavLink: React.FC<DomainNavLinkProps> = ({
  to,
  className,
  onClick,
  onMouseEnter,
  children,
}) => {
  const href = toMarketingUrl(to);
  if (/^https?:\/\//i.test(href)) {
    return (
      <a href={href} className={className} onClick={onClick} onMouseEnter={onMouseEnter}>
        {children}
      </a>
    );
  }
  return (
    <Link to={to} className={className} onClick={onClick} onMouseEnter={onMouseEnter}>
      {children}
    </Link>
  );
};

export default DomainNavLink;
